import styled from "@emotion/styled";

const Textarea = styled.textarea`
  width: 100%;
  min-height: 92px;
  padding: 12px 14px;
  font-size: 14px;
  border: 1px solid #d9dde2;
  border-radius: 10px;
  background: #ffffff;
  color: #222222;
  outline: none;
  resize: vertical;

  &:focus {
    border-color: #003580;
  }
  &::placeholder {
    color: #b8bcc2;
  }
`;

export default Textarea;
